import Select from 'react-select';
import styled from 'styled-components';
import { Controller } from 'react-hook-form';

const StyledSelect = styled(Select)`
  .Select__control {
    height: 40px;
    width: 100%;
    border: 1px solid #a1a1a1;
    border-radius: 0;
    cursor: pointer;
  }

  .Select__control:hover {
    border-color: #a1a1a1;
  }

  .Select__control--is-focused {
    box-shadow: 0 0 0 1px black;
    outline: none;
  }

  .Select__indicator-separator {
    display: none;
  }

  .Select__menu {
    color: #3c3d3e;
  }
`;

export const SelectSearch = ({ control, name, ...props }) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={''}
      render={({ field }) => (
        <StyledSelect
          {...field}
          {...props}
          classNamePrefix="Select"
          onChange={(selectedOption) => field.onChange(selectedOption)}
          noOptionsMessage={() => 'Nenhum resultado encontrado'}
        />
      )}
    />
  );
};
